import {clamp} from 'lodash';

/**
 * Based on the top+left that are coming from the user interaction calculate actual position of the scroll taking size of the Canvas in the account
 */
export const getClampedCanvasScrollPosition = (
  canvasResizeState: {width: number; height: number; scale: number},
  newTargetPosition: {top: number; left: number},
  canvasScrollWidth: number,
  canvasScrollHeight: number
) => {
  const {top, left} = newTargetPosition;

  /**
   * When the canvas `scale` changes, we do not update `canvasResizeState.width` and `canvasResizeState.height`.
   * However, scaling results in change to `body.scrollWidth` and `body.scrollHeight` as we artificially increase the
   * size of the iframe's contents. Therefore, when we calculate the next scroll position we need to take the canvas
   * scale into account when clamping, to avoid setting incorrect values
   */
  const scaledCanvasWidth = Math.round(
    canvasResizeState.width / canvasResizeState.scale
  );
  const scaledCanvasHeight = Math.round(
    canvasResizeState.height / canvasResizeState.scale
  );

  const clampedCanvasScrollPosition = {
    left: clamp(left, 0, canvasScrollWidth - scaledCanvasWidth),
    top: clamp(top, 0, canvasScrollHeight - scaledCanvasHeight),
  } as const;

  return clampedCanvasScrollPosition;
};
